import React, {useContext} from 'react';
import './Devices.scss'
import {MqttClientContext} from "../../context/MqttClientContext";
import * as Yup from "yup";
import {Formik, Form} from "formik";
import mqttRequests from "../../Utils/mqttRequests";
import FormikControl from "../FormTemplate/FormikControl";
import {UserInfoContext} from "../../context/UserInfoContext";
import Cookies from "universal-cookie";

//the page to edit a profile
function EditProfile(props) {

    const cookies = new Cookies(null, {path: '/'});

    const setEditProfile = props.setEditProfile;

    //the profile to edit
    const profile = cookies.get("editProfile");

    //the mqtt client and source
    const {mqttClient, source} = useContext(MqttClientContext);

    //idAccount from context
    const {idAccount} = useContext(UserInfoContext)

    //the initial values for formik
    const initialValues = {
        name: profile.nameProfile,
        description: profile.descrProfile,
    };

    //the yup validation schema
    const validationSchema = Yup.object({
        name: Yup.string().required("Required"),
    });

    //method to edit a profile
    const submitMethod = (value) => {
        //generate operation code
        let operation = mqttRequests.generateOperationCode("editProfile");
        //create json to publish
        let data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '", "idProfile":"' +
            profile.idProfile + '", "oldNameProfile":"' + profile.nameProfile + '", "newNameProfile":"' + value.name + '", "descrProfile":"' + value.description + '"}';

        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/editProfile");
        //publish a demand to edit the profile
        mqttRequests.publish(mqttClient, "profile/editProfile", data);

        operation = mqttRequests.generateOperationCode("getProfile");
        data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '"}';
        mqttRequests.subscribe(mqttClient, "source/" + source + "/getProfile");
        mqttRequests.publish(mqttClient, "profile/getProfile", data);
    };

    return(
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={submitMethod}
            >
                {() => {
                    return(
                        <Form>
                            <FormikControl control="input" type="text" label="Name: " name="name"/>
                            <FormikControl control="textarea" type="text" label="Description: " name="description"/>
                            <button type="submit" className="devicesButton">Validate</button>
                            <button type="button" className="devicesButton" onClick={() => setEditProfile('')}>Cancel</button>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default EditProfile;